import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

export { QueryClientProvider }

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    }
  }
})
